<template>
	<div class="hd-mod-frame-membrane js-mod-frame-membrane">
		<base-image-svg 
			:source="require('!html-loader!../../assets/svgs/18-mod-frame-membrane.svg')"
		/>
	</div>
</template>

<style lang="scss" scoped>
	.hd-mod-frame-membrane {
		:deep() svg {
			max-width: 700px;
			transform: translateY(30%);
			@include fade-out();

			#rna {
				@include fade-out();
				@include animation-float-mini();
			}

			#rna_wrapper {
				transform: translateX(50%) translateY(-50%);
				transition: all 1.5s ease;
			}
		}

		// Animation 
		&[data-state="animation-ready"] {
			:deep() svg {
				@include transition-frame-fade-in();

				#rna, #rna_wrapper {
					@include transition-frame-fade-in();
				}
			}
		}

		// Responsive 
		@include res-screen-small {
			:deep() svg {
				max-width: 450px;
			}
		}
		@include res-screen-x-small {
			:deep() svg {
				max-width: 350px;
			}
		}

		@include res-screen-portrait {
			@include center();
			top: 60%;

			:deep() svg {
				max-width: 100%;
			}
		}
	}
</style>